<template>
    <div v-html="fieldsLabel"></div>
</template>
<script>
    import {fieldDisplay} from "./mixins/fieldDisplay";

    export default {
        mixins:[fieldDisplay],
    }
</script>
